
import * as THREE from 'three';
import { RebarElement, Element } from './types';
import { RebarShapeManager } from './RebarShapeManager';
import { mergeGeometriesIntoMesh } from '../rendering/instancing/mergeGeometries';

export class RebarSolver {

    static solve(rebar: RebarElement, host: Element): THREE.Mesh {
        const layout = rebar.geometryData;
        const shape = RebarShapeManager.getShape(layout.shapeId);

        if (!shape) return new THREE.Mesh();

        // 1. Get Host Dimensions (Simplification: Access generic geometryData if available)
        // In reality, we'd need exact bounding box or "Core" boundary of host.
        // Let's assume Host has a simple box for now.
        const hostSize = new THREE.Vector3(0.5, 0.5, 3.0); // Default Column size generic
        if (host.category === 'Structural Columns' && (host as any).geometryData) {
            // Mapping column geometry to size
            // const colData = (host as any).geometryData;
            // hostSize.set(colData.width, colData.depth, colData.height);
            // TODO: Real extraction
        }

        const cover = 0.04; // 40mm default

        // 2. Resolve Single Bar Geometry
        const shapeGeo = RebarShapeManager.resolveShapeGeometry(layout.shapeId, hostSize, cover);
        if (shapeGeo.points.length < 2) return new THREE.Mesh();

        // 3. Apply Layout Rule (Quantity, Spacing) to generate multiple bars
        const geometries: THREE.BufferGeometry[] = [];

        // RebarTool stores the resolved set on geometryData as
        // numberOfBars + distribution.spacing (mm); the legacy RebarElement
        // shape uses quantity/spacing (m). Read both so placed sets render
        // their whole bar family instead of collapsing to a single bar.
        const g = layout as any;
        const count = Math.max(1, g.quantity ?? g.numberOfBars ?? 1);
        const spacingMm = g.distribution?.spacing;
        const spacing = typeof g.spacing === 'number' && g.spacing > 0
            ? g.spacing
            : typeof spacingMm === 'number' && spacingMm > 0
                ? spacingMm / 1000
                : 0.2; // 200mm

        // Distribution Path: e.g. Along Z axis for Stirrups in a Column relative to host origin
        const distributionDir = new THREE.Vector3(0, 0, 1);
        const startOffset = new THREE.Vector3(cover, cover, cover); // Bottom-Left-Corner + Cover

        // Generate Curve for tube
        const curve = new THREE.CatmullRomCurve3(shapeGeo.points, false, 'catmullrom', 0.05);
        const tubeGeo = new THREE.TubeGeometry(curve, 10, layout.barDiameter / 2000, 8, false); // diam is mm, convert to meters radius

        for (let i = 0; i < count; i++) {
            const instanceGeo = tubeGeo.clone();

            // Calc Position
            const pos = startOffset.clone().add(distributionDir.clone().multiplyScalar(i * spacing));

            instanceGeo.translate(pos.x, pos.y, pos.z);
            geometries.push(instanceGeo);
        }

        // 4. Merge via BufferGeometryUtils (task 3.2: resolves former TODO merge)
        return mergeGeometriesIntoMesh(geometries);
    }
}
